var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTtsNarrate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.8C4 2.15 4.72 1.76 5.26 2.13L13.26 8.33C13.73 8.65 13.73 9.35 13.26 9.67L5.26 15.87C4.72 16.24 4 15.85 4 15.2V2.8Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6.5C15.3 7.3 15.8 8.3 15.8 9C15.8 9.7 15.3 10.7 14.5 11.5",
    stroke: "#6B7280",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtsNarrate);
export default __webpack_public_path__ + "static/media/tts_narrate.d11f84c63191db76c36118ce54552d75.svg";
export { ForwardRef as ReactComponent };